export class ReportGroup {
    constructor() {}
    public groupId: number = -1;
    public groupName: string = '';
    public ownerEmail: string = '';
    public member: GroupMember[] = [];
}


export class GroupMember
{
    public email: string = "";
    public name: string = "";
}